import { gql } from '@apollo/client';

export const DecodeGQL = gql`
  query Decode($vin: String!) {
    decode(vin: $vin) {
      vin
      year
      make
      model
      styles {
        provider
        styleId
        title
        series
      }
    }
  }
`;

const decodeAttributesGQL = gql`
  fragment DecodeAttributes on Decode {
    vin
    year
    make
    model
    provider
    styleId
    styleName
    vehiclePhoto
    valuations {
      avg
      clean
      rough
      xclean
    }
    valuationsByMileage {
      rangeBegin
      rangeEnd
      conditionValues {
        xclean
        clean
        avg
        rough
      }
    }
  }
`;

const questionGroupAttributesGQL = gql`
  fragment QuestionGroupAttributes on QuestionGroup {
    title
    key
    displayRule
    editable
    category
    requiresConfirmation
  }
`;

const questionAttributesGQL = gql`
  fragment QuestionAttributes on Question {
    answer {
      code
      value
      default
      extra
      type
    }
    title
    key
    type
    displayRule
    validationRule
    requiresAnswer
    coachNote
    answerTitle
    answerFunction
    options {
      code
      value
      default
      extra
    }
    imagesPlaceholders {
      name
      url
    }
    imagesPlaceholdersForCamera {
      name
      url
    }
  }
`;

export const RetrieveSubmissionsGQL = gql`
  ${decodeAttributesGQL}
  ${questionGroupAttributesGQL}
  ${questionAttributesGQL}
  query RetrieveSubmissions($externalId: String!) {
    submissions(externalId: $externalId) {
      id
      type
      decode {
        ...DecodeAttributes
      }
      questionGroups {
        ...QuestionGroupAttributes
        questions {
          ...QuestionAttributes
          answer {
            code
            value
            extra
            default
          }
        }
      }
    }
  }
`;

export const RetrieveAllSubmissionsGQL = gql`
  query RetrieveAllSubmissions {
    findAllByUserId {
      id
      externalId
    }
  }
`;

export const StructureGQL = gql`
  ${decodeAttributesGQL}
  ${questionGroupAttributesGQL}
  ${questionAttributesGQL}
  query Structure($vin: String!, $style: StyleInput!, $type: String, $preloadedAnswers: [preloadedAnswersInput]) {
    structure(vin: $vin, style: $style, type: $type, preloadedAnswers: $preloadedAnswers) {
      decode {
        ...DecodeAttributes
      }
      questionGroups {
        ...QuestionGroupAttributes
        questions {
          ...QuestionAttributes
        }
      }
    }
  }
`;

export const SubmitGQL = gql`
  mutation Mutation($structure: StructureInput!) {
    submit(structure: $structure) {
      id
      externalId
    }
  }
`;

export const SubmitEditGQL = gql`
  mutation EditSubmission($structure: StructureInput!, $externalId: String!) {
    editSubmission(structure: $structure, externalId: $externalId) {
      id
      externalId
    }
  }
`;
